import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";

export const TanyaBannerWrapper = styled.section`
  background: ${({ theme }) => theme.colors.brand[800]};
  padding: 40px 0 0 0;
  color: ${({ theme }) => theme.colors.white};

  @media ${breakpoints.tablet} {
    padding: 40px 0 0 30px;
  }
`;

export const TanyaBannerContainer = styled(Container)`
  padding: 0 16px;
  @media ${breakpoints.tablet} {
    display: grid;
    grid-gap: 150px;
    justify-content: space-around;
    align-items: center;
    grid-template-columns: 1fr minmax(300px, 1fr);
    overflow: hidden;
    margin: 0 auto;
  }
`;
export const TanyaBannerContentContainer = styled.div`
  padding: 0 30px 50px 30px;
  @media ${breakpoints.tablet} {
    padding: 0 0 50px 0;
    max-width: 380px;
    margin: 0;
    justify-self: flex-end;
  }
`;

export const TanyaBannerTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-weight: bold;
  margin: 0 0 12px 0;
  line-height: 1.5;
`;

export const TanyaBannerTitleHighlight = styled.span`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.yellow[500]};
`;
export const TanyaBannerDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  margin: 0 0 24px 0;
`;

export const TanyaBannerFeaturesContainer = styled.ul`
  margin: 0 0 24px 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TanyaBannerFeatureItem = styled.li`
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &:before {
    content: "✓";
    min-width: 24px;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.colors.green[500]};
    color: ${({ theme }) => theme.colors.brand[800]};
    border-radius: 50%;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TanyaBannerButton = styled.button`
  --webkit-appearance: none;
  background-color: ${({ theme }) => theme.colors.brand["500"]};
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: none;
  border: none;
  cursor: pointer;
  max-width: 220px;
  white-space: nowrap;
`;

export const TanyaBannerImageWrapper = styled.figure`
  margin: 50px auto 0 auto;
  position: relative;
  width: 100%;

  @media ${breakpoints.tablet} {
    align-self: flex-end;
  }
`;
